module.exports = __webpack_public_path__ + "static/media/shortinglistup-white.2d0fb179.svg";